import React, { useState } from 'react'
import "./navbarMenu.css"

const planets:string[] = ["Mercury", "Venus", "Earth", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune"];


const NavbarMenu = ({onSetPlanet}:{onSetPlanet:any}) => {
  const [openMenu, setOpenMenu]=useState<boolean>(true)

  return (
    <div id='navbarMenu'>
      <button className={`menuBtn ${openMenu && "hidden"} `}>
        <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="3" fill="white"/>
          <rect y="7" width="24" height="3" fill="white"/>
          <rect y="14" width="24" height="3" fill="white"/>
        </svg>
      </button>
      <div >
        {planets.map(planet => (
          <button onClick={()=>{onSetPlanet(planet)}} key={planet}>{planet}</button>
        ))}
      </div>
    </div>
  )
}

export default NavbarMenu
